namespace RioERP.Products {
    export interface ProductSpecificationsBooksRow {
        Id?: number;
        BookId?: number;
        ProductSpecificationId?: number;
        ProductId?: number;
        IsActive?: boolean;
        ProductSpecificationSpecificationName?: string;
        ProductSpecificationProductId?: number;
        ProductSpecificationSpecificationCode?: number;
        ProductSpecificationHasBooks?: boolean;
        ProductSpecificationHasPendrive?: boolean;
        ProductSpecificationIsLive?: boolean;
        ProductSpecificationProcessOrderOnPaid?: boolean;
        ProductSpecificationEopens?: number;
        ProductSpecificationEWatchtime?: number;
        ProductSpecificationEValidityType?: number;
        ProductSpecificationEValidity?: number;
        ProductSpecificationValidTill?: string;
        ProductSpecificationAllowedDevices?: string;
        ProductSpecificationHasCourier?: boolean;
        ProductSpecificationInsertUserId?: number;
        ProductSpecificationInsertDate?: string;
        ProductSpecificationUpdateUserId?: number;
        ProductSpecificationUpdateDate?: string;
        InsertUserId?: number;
        InsertDate?: string;
        UpdateUserId?: number;
        UpdateDate?: string;
    }

    export namespace ProductSpecificationsBooksRow {
        export const idProperty = 'Id';
        export const localTextPrefix = 'Products.ProductSpecificationsBooks';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            BookId = "BookId",
            ProductSpecificationId = "ProductSpecificationId",
            ProductId = "ProductId",
            IsActive = "IsActive",
            ProductSpecificationSpecificationName = "ProductSpecificationSpecificationName",
            ProductSpecificationProductId = "ProductSpecificationProductId",
            ProductSpecificationSpecificationCode = "ProductSpecificationSpecificationCode",
            ProductSpecificationHasBooks = "ProductSpecificationHasBooks",
            ProductSpecificationHasPendrive = "ProductSpecificationHasPendrive",
            ProductSpecificationIsLive = "ProductSpecificationIsLive",
            ProductSpecificationProcessOrderOnPaid = "ProductSpecificationProcessOrderOnPaid",
            ProductSpecificationEopens = "ProductSpecificationEopens",
            ProductSpecificationEWatchtime = "ProductSpecificationEWatchtime",
            ProductSpecificationEValidityType = "ProductSpecificationEValidityType",
            ProductSpecificationEValidity = "ProductSpecificationEValidity",
            ProductSpecificationValidTill = "ProductSpecificationValidTill",
            ProductSpecificationAllowedDevices = "ProductSpecificationAllowedDevices",
            ProductSpecificationHasCourier = "ProductSpecificationHasCourier",
            ProductSpecificationInsertUserId = "ProductSpecificationInsertUserId",
            ProductSpecificationInsertDate = "ProductSpecificationInsertDate",
            ProductSpecificationUpdateUserId = "ProductSpecificationUpdateUserId",
            ProductSpecificationUpdateDate = "ProductSpecificationUpdateDate",
            InsertUserId = "InsertUserId",
            InsertDate = "InsertDate",
            UpdateUserId = "UpdateUserId",
            UpdateDate = "UpdateDate"
        }
    }
}
